import React from 'react';
import { IconButton } from '@material-ui/core';
import {
  Create as EditIcon,
  Visibility as ViewIcon,
  Delete as DeleteIcon,
} from '@material-ui/icons';
import Table, {
  columnType,
  tempFilteredRows,
} from '../../../../components/ClearingTable/Table';
import {
  deleteSplit,
  listSplit,
  updateSplit,
} from '../../../../services/ReorgAnnouncement';
import {
  notifyError,
  notifySuccess,
  notifyInfo,
} from '../../../../components/Messages/Notification';
import { splitColumns } from '../../../../lib/data/columns';
import SplitModal from './SplitModal';
import DetailModal from './DetailModal';
import {
  CustomBodyRenderCurrency,
  CustomBodyRenderCurrencyLeft,
  CustomBodyRenderDate,
  CustomBodyRenderDateTime,
  CustomBodyRenderBoolean,
  CustomBodyRenderAlign,
  CustomBodyRenderHtmlString,
  CustomBodyRenderCenter,
  CustomBodyRenderQty,
} from '../../../../components/Table/CustomBodyRender';
import { formatPbDate, formatPbDateTime } from '../../../../lib/fmt';
import { formatCurrencySymbol, formatQty } from '../../../../lib/fmt2';

export default function SplitTable({
  newRows,
  searchData,
  announcementType,
  loading,
  summary,
  resetFooters,
}) {
  const [currentRowsPerPage, setCurrentRowsPerPage] = React.useState(100);
  const [totalRows, setTotalRows] = React.useState(0);
  const [pagination, setPagination] = React.useState({});
  const [footerData, setFooterData] = React.useState({});
  const [rows, setRows] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [open, setOpen] = React.useState({
    edit: false,
    view: false,
  });
  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => {
    if (announcementType == 'split') {
      getRows();
    }
  }, [newRows]);

  const GridButtons = ({ tableManager, value, data, column, colIndex, rowIndex }) => {
    return (
      <div className="grd-row">
        {/* <div className='grd-cell nm'>
          <IconButton aria-label="edit" onClick={() => handleOpen(data)}>
            <EditIcon style={{ height: 24, width: 24 }} />
          </IconButton>
        </div> */}
        <div className="grd-cell nm">
          <IconButton aria-label="view" onClick={() => handleView(data)}>
            <ViewIcon style={{ height: 24, width: 24 }} />
          </IconButton>
        </div>
        {/* <div className='grd-cell nm'>
          <IconButton disabled={!isDeleteEnabled(data)} aria-label="delete" onClick={() => handleDelete(data)}>
            <DeleteIcon style={{ height: 24, width: 24 }} />
          </IconButton>
        </div> */}
      </div>
    );
  };

  const columns2 = [
    {
      id: '',
      label: '',
      width: '100px',
      cellRenderer: GridButtons,
    },
    ...splitColumns,
  ];

  const columns = [
    {
      name: 'actions',
      label: 'Actions',
      type: columnType.buttons,
      options: {
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              <IconButton
                aria-label="view"
                onClick={() => handleView(tempFilteredRows[dataIndex])}
              >
                <ViewIcon style={{ height: 24, width: 24 }} />
              </IconButton>
            </div>
          );
        },
        sort: false,
      },
    },
    {
      name: 'textNumber',
      label: 'Text Number',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      // Already converted to string in handlesearch
      name: 'systemDate',
      label: 'System Date',
    },
    {
      // Already converted to string in handlesearch
      name: 'expirationDate',
      label: 'Expiration Date',
    },
    {
      name: 'targetSymbol',
      label: 'Target Symbol',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'targetOriginalCusip',
      label: 'Target Original Cusip',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'initiatingSymbol',
      label: 'Initiating Symbol',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'initiatingOriginalCusip',
      label: 'Initiating Original Cusip',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'cash',
      label: 'Cash',
      options: {
        customBodyRender: CustomBodyRenderCurrencyLeft,
      },
      addFooter: true,
      type: columnType.amount,
    },
    {
      name: 'newRate',
      label: 'New Qty',
      options: {
        customBodyRender: CustomBodyRenderQty,
      },
      addFooter: true,
      type: columnType.quantity,
    },
    {
      name: 'oldRate',
      label: 'Old Qty',
      options: {
        customBodyRender: CustomBodyRenderQty,
      },
      addFooter: true,
      type: columnType.quantity,
    },
    {
      name: 'splitType',
      label: 'Split Type',
      options: {
        customBodyRender: CustomBodyRenderAlign,
        display: false,
      },
    },
    {
      // Already converted to string in handlesearch
      name: 'recordDate',
      label: 'Record Date',
      options: {
        display: false,
      },
    },
    {
      // Already converted to string in handlesearch
      name: 'positionDate',
      label: 'Position Date',
      options: {
        display: false,
      },
    },
    {
      // Already converted to string in handlesearch
      name: 'processDate',
      label: 'Process Date',
      options: {
        display: false,
      },
    },
    {
      name: 'detail',
      label: 'Detail',
      options: {
        customBodyRender: CustomBodyRenderHtmlString,
        display: false,
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'a-selectAll',
      label: 'Select All',
      options: {
        display: true,
        print: false,
        download: false,
        filter: false,
        setCellHeaderProps: () => ({
          style: {
            width: '0px',
            display: 'table-cell',
            padding: 0,
            pointerEvents: 'none',
            fontSize: 0,
          },
        }),
      },
    },
  ];

  const options = {
    selectableRows: 'none',
    responsive: 'standard',
    serverSide: true,
  };

  const handleOpen = (data) => {
    setRowData(data);
    setOpen({
      ...open,
      edit: true,
    });
  };

  const handleView = (data) => {
    setRowData(data);
    setOpen({
      ...open,
      view: true,
    });
  };

  const handleClose = async (data) => {
    if (!data) {
      setOpen({
        view: false,
        edit: false,
      });
      return;
    }

    setSaving(true);
    try {
      const { split } = await updateSplit(data);

      notifySuccess('Split has been updated');
    } catch (error) {
      console.error(error);
      notifyError(error.message);
    }

    getRows();
    setSaving(false);
    setOpen({
      view: false,
      edit: false,
    });
  };

  const isDeleteEnabled = (data) => {
    if (data.status == 'Active') {
      return true;
    }
    return false;
  };

  const handleDelete = async (data) => {
    try {
      await deleteSplit(data.splitId);

      notifySuccess('Split has been deactivated');
      getRows(false);
    } catch (error) {
      console.error(error);
      notifyError(error.message);
    }
  };

  const getRows = async (paginationChange) => {
    let paginationCopy = {
      ...pagination,
      reload: false,
      pageNo: paginationChange === true ? pagination.pageNo : 0,
      rowsPerPage: pagination.rowsPerPage || 100,
    };
    if (currentRowsPerPage != paginationCopy.rowsPerPage) {
      setCurrentRowsPerPage(paginationCopy.rowsPerPage);
      paginationCopy.pageNo = 0;
    }

    if (!!paginationChange) {
      const data = await listSplit(searchData, paginationCopy);

      let rowsCopy = data.splitsList;
      const rowsCopyOutput = rowsCopy.map((data) => {
        let tempDate1 = formatPbDate(data.expirationDate);
        data.expirationDate = tempDate1;

        let tempDate2 = formatPbDate(data.positionDate);
        data.positionDate = tempDate2;

        let tempDate3 = formatPbDate(data.processDate);
        data.processDate = tempDate3;

        let tempDate4 = formatPbDate(data.recordDate);
        data.recordDate = tempDate4;

        let tempDate5 = formatPbDate(data.systemDate);
        data.systemDate = tempDate5;

        return data;
      });
      paginationCopy.count = data.summary.totalRows;
      setTotalRows(data.summary.totalRows);
      setPagination(paginationCopy);
      setRows(rowsCopyOutput);
      setFooterData({
        cash: formatCurrencySymbol(data.summary.cash),
        newRate: formatQty(data.summary.newRate),
        oldRate: formatQty(data.summary.oldRate),
      });
    } else {
      paginationCopy.count = summary.totalRows;
      setTotalRows(summary.totalRows);
      setPagination(paginationCopy);
      setRows(newRows);
      if (!!resetFooters) {
        setFooterData({
          cash: formatCurrencySymbol(0),
          newRate: formatQty(0),
          oldRate: formatQty(0),
        });
      } else {
        setFooterData({
          cash: formatCurrencySymbol(summary.cash),
          newRate: formatQty(summary.newRate),
          oldRate: formatQty(summary.oldRate),
        });
      }
    }
  };

  const getCsvData = async () => {
    if (!totalRows) return [];
    let paginationCopy = {
      ...pagination,
      reload: false,
      pageNo: 0,
      rowsPerPage: totalRows,
    };
    const data = await listSplit(searchData, paginationCopy);
    let rowsCopy = data.splitsList;
    const rowsCopyOutput = rowsCopy.map((data) => {
      let tempDate1 = formatPbDate(data.expirationDate);
      data.expirationDate = tempDate1;

      let tempDate2 = formatPbDate(data.positionDate);
      data.positionDate = tempDate2;

      let tempDate3 = formatPbDate(data.processDate);
      data.processDate = tempDate3;

      let tempDate4 = formatPbDate(data.recordDate);
      data.recordDate = tempDate4;

      let tempDate5 = formatPbDate(data.systemDate);
      data.systemDate = tempDate5;

      return data;
    });

    return rowsCopyOutput;
  };

  return (
    <div className="mt-20">
      <Table
        title={'Split'}
        data={rows}
        columns={columns}
        options={options}
        pagination={pagination}
        setPagination={setPagination}
        onSearch={getRows}
        getCsvData={getCsvData}
        footerData={footerData}
      />
      {open.edit && (
        <SplitModal
          data={rowData}
          open={open.edit}
          close={handleClose}
          isEdit={true}
          loading={saving}
        />
      )}

      {open.view && (
        <DetailModal
          data={rowData}
          open={open.view}
          close={handleClose}
          title={'Split'}
        />
      )}
    </div>
  );
}
